import { ReactNode } from "react";
import { DatasetStatus } from "types";
import styles from "../style.module.scss";
import { Typography } from "antd";
import { useReindex } from "hooks/useReindex";
import ReindexModal from "views/components/ContainerHeader/ReindexModal";
import { useVisibility } from "hooks/useVisibility";

interface DisabledLabelPropagationProps {
  datasetStatus: DatasetStatus;
  datasetId: string;
}

export default function DisabledLabelPropagation({
  datasetStatus,
  datasetId,
}: DisabledLabelPropagationProps) {
  const { isLoading } = useReindex(datasetId);

  const {
    isOpen: isReindexModalOpen,
    open: openReindexModal,
    close: closeReindexModal,
  } = useVisibility();

  const DefaultDisabledMessage = (
    <div>
      This feature isn't available for {datasetStatus.toLowerCase()} dataset.
    </div>
  );

  const ProgressingDisabledMessage = (
    <div>
      This feature isn't available for dataset during{" "}
      {datasetStatus.toLowerCase()}.
    </div>
  );

  const { Link } = Typography;

  const PendingIndexDisabledMessage = (
    <div>
      This feature isn't available for {datasetStatus.toLowerCase()} dataset.
      You'll need to re-index the dataset. You can{" "}
      <Link onClick={openReindexModal} disabled={isLoading}>
        do it now
      </Link>{" "}
      or wait if more data is coming
      {isLoading && " (starting reindex...)"}
    </div>
  );

  const statusMessages: Record<DatasetStatus, ReactNode | null> = {
    [DatasetStatus.READY]: null,
    [DatasetStatus.INDEXING]: ProgressingDisabledMessage,
    [DatasetStatus.DRAFT]: DefaultDisabledMessage,
    [DatasetStatus.ERROR]: DefaultDisabledMessage,
    [DatasetStatus.PARTIAL_INDEX]: PendingIndexDisabledMessage,
    [DatasetStatus.READ_ONLY]: DefaultDisabledMessage,
  };

  const message = statusMessages[datasetStatus];

  if (!message) {
    return null;
  }

  return (
    <>
      <div className={styles.notEnabled}>{message}</div>
      <ReindexModal open={isReindexModalOpen} onClose={closeReindexModal} />
    </>
  );
}
